// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72964323","833":"b30777f2","872":"ec619b04"}[chunkId] + ".chunk.js";
};